// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__M236U","right":"styles_right__1CxRO"};